<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	export default {
		data() {
			return {
				//表格
				size: 'mini',
				shaidiag: false,
				headData: JSON.parse(localStorage.getItem('AvailableTaxRatesheadData')) || getdata().headData,
				outlist: JSON.parse(localStorage.getItem('AvailableTaxRatesoutlist')) || [],
				pagination: getdata().pagination, //分页数据
				tableData: [{
					parameterProperty: "1",
					taxRate: "0.06",
					effectiveDateEnd: "2013-08-01 00:00:00",
					parameterStatus: "0",
					disableDate: "",
					taxRateLogo: "Y",
					correspondingOriginalTaxRate: "",
				}, {
					parameterProperty: "1",
					taxRate: "0.09",
					effectiveDateEnd: "2019-04-01 00:00:00",
					parameterStatus: "0",
					disableDate: "",
					taxRateLogo: "Y",
					correspondingOriginalTaxRate: "13%、11%、10%",
				}, {
					parameterProperty: "1",
					taxRate: "0.13",
					effectiveDateEnd: "2022-06-07 00:00:00",
					parameterStatus: "0",
					disableDate: "2025-12-31 00:00:00",
					taxRateLogo: "Y",
					correspondingOriginalTaxRate: "",
				}, {
					parameterProperty: "1",
					taxRate: "0.13",
					effectiveDateEnd: "2022-06-07 00:00:00",
					parameterStatus: "1",
					disableDate: "2025-12-31 00:00:00",
					taxRateLogo: "N",
					correspondingOriginalTaxRate: "",
				}, {
					parameterProperty: "0",
					taxRate: "0.05",
					effectiveDateEnd: "2022-06-07 00:00:00",
					parameterStatus: "0",
					disableDate: "2025-12-31 00:00:00",
					taxRateLogo: "Y",
					correspondingOriginalTaxRate: "",
				}], //表格内容数据
				tablekey: 0,
				//排序字段
				order: '',
				//排序顺序
				sort: '',
				//筛选数据
				param: {
					disableDate: [],
					effectiveDate: [],
					originalTaxRateLogo: ['Y', 'N'],
					status: ['0', '1'],
					updateTime: ""
				}
			};
		},
		mounted() {},
		created() {
			this.initialization();
		},
		methods: {
			//时间戳转时间
			timestampToTimesfm(timestamp) {
				// 时间戳为10位需*1000，时间戳为13位不需乘1000
				if (timestamp) {
					var date = new Date(timestamp);
					var Y = date.getFullYear() + '年';
					var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '月';
					var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + '日 ';
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					// return Y + M + D;
					return Y + M + D + h + m + s;
				}
			},
			//初始化
			initialization() {
				let params = {};
				params.limit = this.pagination.pageSize;
				params.page = this.pagination.pageNum;
				params.sort = this.sort;
				params.order = this.order;
				params.param = this.param;
				this.$https.fetchPost('/natural/taxRate/findAvailableTaxRate', params).then(res => {
					if (res.data.code == '200') {
						if (res.data.data != null) {
							this.tableData = res.data.data;
							if (this.tableData.length > 0) {
								this.updateTime = this.tableData[0].updateTime
							}
						}
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//更新基本信息
			UpdateBasicInformation() {
				this.$https.fetchPost('/natural/taxRate/updateAvailableTaxRate').then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.message);
						this.initialization();
					} else {
						this.$message.error('更新可用税率失败'+res.data.message);
					}
				});
			},

			forSearchScreeningBox(obj) {
				this.param = {
					disableDate: obj.disableDate,
					effectiveDate: obj.effectiveDateEnd,
					originalTaxRateLogo: obj.taxRateLogo,
					status: obj.parameterStatus
				};
				this.initialization();
				console.log(obj); //筛选数组
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.initialization();
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				this.initialization();
			},
			//表格筛选
			closeshaidiag() {
				this.shaidiag = false;
			},
			//表格体 排序
			sortchange(e) {
				if (e.order != null) {
					this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
					this.order = e.prop;
				} else {
					this.sort = '';
					this.order = '';
				}
				this.initialization();
			}, //筛选数组
			confirmfilter(e) {
				localStorage.setItem('AvailableTaxRatesoutlist', JSON.stringify(e.nochooselist));
				localStorage.setItem('AvailableTaxRatesheadData', JSON.stringify(e.chooselist));
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
				this.$refs.tablebox.dout();
				this.tablekey++;
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>